import React from 'react';
import {
  DemoPackage3dAddOns,
  DemoPackage3dInclude,
  DemoPackageAerialAddOns,
  DemoPackageAerialInclude,
  DemoPackageCommunityAddOn,
  DemoPackageFloorplanAddOns,
  DemoPackageFloorplanInclude,
  DemoPackagePhotoAddOns,
  DemoPackagePhotoInclude,
} from '~/tenants/demo/package/common';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import { PersonaType } from '~/tenants/common/TenantPersona';

export default function DemoPackagePremiumForm() {
  return (
    <>
      <TenantPackageIncludes>
        <DemoPackagePhotoInclude />
        <DemoPackageFloorplanInclude />
        <DemoPackage3dInclude />
        <DemoPackageAerialInclude />
      </TenantPackageIncludes>
      <TenantPerformableAddOns persona={PersonaType.CUSTOMER}>
        <DemoPackagePhotoAddOns />
        <DemoPackageFloorplanAddOns />
        <DemoPackage3dAddOns />
        <DemoPackageAerialAddOns />
        <DemoPackageCommunityAddOn aerial />
      </TenantPerformableAddOns>
    </>
  );
}
